import { render, staticRenderFns } from "./tab-recruitment.vue?vue&type=template&id=0cb8ea70&scoped=true"
import script from "./tab-recruitment.vue?vue&type=script&lang=js"
export * from "./tab-recruitment.vue?vue&type=script&lang=js"
import style0 from "./tab-recruitment.vue?vue&type=style&index=0&id=0cb8ea70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb8ea70",
  null
  
)

export default component.exports